// AUTO-GENERATED — do not edit. Run `pnpm build` in packages/domain-data.
// Source: business/ishvaram/data/domain/astrology/tarot.yaml

import type { TarotReferenceCard } from "./types";

export const cupsTarotCards = [
  {
    image_description: "",
    id: 36,
    name_en: "Ace of Cups",
    name_hi: "कलश का इक्का",
    vedic_name: "Amrit Kalash (The Nectar Vessel)",
    vedic_parallel: "Like the amrit emerging from the cosmic ocean — divine love overflowing",
    upright: {
      keywords: ["new love", "emotional beginning", "compassion", "creativity"],
      meaning:
        "A new emotional or spiritual beginning. Love, compassion, or creative inspiration flows.",
      advice: "Open your heart. What arrives now is genuine.",
    },
    reversed: {
      keywords: ["emotional blockage", "emptiness", "repressed feelings"],
      meaning: "Emotions are blocked or you are not allowing yourself to feel.",
      advice: "Release what you are holding back. Vulnerability is strength.",
    },
    arcana: "minor",
    suit: "cups",
    element: "water",
    vedic_element: "jal",
    suit_theme: "Emotions, love, relationships, and spiritual connection",
  },
  {
    image_description: "",
    id: 37,
    name_en: "Two of Cups",
    name_hi: "कलश का दो",
    vedic_name: "Prema Bandhan (The Bond of Love)",
    vedic_parallel: "Like the Gandharva vivah — a union born of mutual respect and attraction",
    upright: {
      keywords: ["partnership", "mutual attraction", "unity", "connection"],
      meaning: "A meaningful connection forms — romantic, business, or spiritual.",
      advice: "Invest in this bond. Genuine partnerships are rare and valuable.",
    },
    reversed: {
      keywords: ["imbalance", "breakup", "miscommunication", "distrust"],
      meaning: "A relationship is out of balance. One side gives more than it receives.",
      advice: "Communicate honestly before resentment builds.",
    },
    arcana: "minor",
    suit: "cups",
    element: "water",
    vedic_element: "jal",
    suit_theme: "Emotions, love, relationships, and spiritual connection",
  },
  {
    image_description: "",
    id: 38,
    name_en: "Three of Cups",
    name_hi: "कलश का तीन",
    vedic_name: "Ananda Sabha (The Gathering of Joy)",
    vedic_parallel: "Like the celebrations at Diwali — shared joy among community and friends",
    upright: {
      keywords: ["celebration", "friendship", "community", "creativity", "joy"],
      meaning: "Joyful celebration with kindred spirits. Community strengthens you.",
      advice: "Celebrate together. Shared joy is multiplied joy.",
    },
    reversed: {
      keywords: ["gossip", "overindulgence", "isolation from friends"],
      meaning: "Social dynamics are strained. Gossip or excess damages bonds.",
      advice: "Check if you are giving or taking too much in friendships.",
    },
    arcana: "minor",
    suit: "cups",
    element: "water",
    vedic_element: "jal",
    suit_theme: "Emotions, love, relationships, and spiritual connection",
  },
  {
    image_description: "",
    id: 39,
    name_en: "Four of Cups",
    name_hi: "कलश का चार",
    vedic_name: "Virakti (The Disenchantment)",
    vedic_parallel:
      "Like Siddhartha seeing suffering for the first time — dissatisfaction that sparks seeking",
    upright: {
      keywords: ["apathy", "contemplation", "dissatisfaction", "missed opportunity"],
      meaning: "Dissatisfaction with what is offered. A new opportunity may go unnoticed.",
      advice: "Look around. What you seek may already be in front of you.",
    },
    reversed: {
      keywords: ["renewed interest", "awareness", "seizing opportunity"],
      meaning: "The fog of apathy lifts. You begin to see value in what was overlooked.",
      advice: "Act on the renewed awareness before it fades.",
    },
    arcana: "minor",
    suit: "cups",
    element: "water",
    vedic_element: "jal",
    suit_theme: "Emotions, love, relationships, and spiritual connection",
  },
  {
    image_description: "",
    id: 40,
    name_en: "Five of Cups",
    name_hi: "कलश का पाँच",
    vedic_name: "Shoka (The Grief)",
    vedic_parallel:
      "Like Arjuna's despair on the battlefield — focusing on loss while blessings remain",
    upright: {
      keywords: ["grief", "loss", "regret", "disappointment", "mourning"],
      meaning: "Grief over what was lost. Two cups remain upright — not all is gone.",
      advice: "Mourn what you must, then turn around. Hope still stands behind you.",
    },
    reversed: {
      keywords: ["acceptance", "moving on", "finding peace", "recovery"],
      meaning: "The healing begins. You are ready to see what remains.",
      advice: "Forgive the past. What is left is enough to rebuild.",
    },
    arcana: "minor",
    suit: "cups",
    element: "water",
    vedic_element: "jal",
    suit_theme: "Emotions, love, relationships, and spiritual connection",
  },
  {
    image_description: "",
    id: 41,
    name_en: "Six of Cups",
    name_hi: "कलश का छह",
    vedic_name: "Smriti (The Memory)",
    vedic_parallel: "Like returning to a childhood temple — innocence and nostalgia that nourishes",
    upright: {
      keywords: ["nostalgia", "innocence", "childhood", "reunion", "generosity"],
      meaning: "Sweet memories or a reunion from the past. Innocence returns briefly.",
      advice: "Reconnect with what once brought you pure joy.",
    },
    reversed: {
      keywords: ["stuck in the past", "refusing to grow", "naivety"],
      meaning: "Living in memories instead of the present. The past cannot be relived.",
      advice: "Honor the past but build the future.",
    },
    arcana: "minor",
    suit: "cups",
    element: "water",
    vedic_element: "jal",
    suit_theme: "Emotions, love, relationships, and spiritual connection",
  },
  {
    image_description: "",
    id: 42,
    name_en: "Seven of Cups",
    name_hi: "कलश का सात",
    vedic_name: "Maya Jaal (The Web of Illusions)",
    vedic_parallel: "Like the many forms of Maya — desires multiply, but which is real?",
    upright: {
      keywords: ["choices", "fantasy", "illusion", "wishful thinking", "options"],
      meaning: "Many options appear, but not all are real. Discernment is needed.",
      advice: "Choose one path and commit. Fantasy without action is a trap.",
    },
    reversed: {
      keywords: ["clarity of choice", "determination", "focused action"],
      meaning: "Illusions clear and you see the real choice. Clarity arrives.",
      advice: "Act on what is real, not what is tempting.",
    },
    arcana: "minor",
    suit: "cups",
    element: "water",
    vedic_element: "jal",
    suit_theme: "Emotions, love, relationships, and spiritual connection",
  },
  {
    image_description: "",
    id: 43,
    name_en: "Eight of Cups",
    name_hi: "कलश का आठ",
    vedic_name: "Tyag (The Renunciation)",
    vedic_parallel: "Like Mahavira leaving his kingdom — walking away from comfort to find truth",
    upright: {
      keywords: ["walking away", "seeking truth", "disillusionment", "departure"],
      meaning: "Something that once fulfilled you no longer does. It is time to walk away.",
      advice: "Leave with grace. What you seek is not here anymore.",
    },
    reversed: {
      keywords: ["fear of change", "staying in comfort", "drifting aimlessly"],
      meaning: "You know you should leave but fear holds you in place.",
      advice: "The comfort zone has become a cage. Take the first step.",
    },
    arcana: "minor",
    suit: "cups",
    element: "water",
    vedic_element: "jal",
    suit_theme: "Emotions, love, relationships, and spiritual connection",
  },
  {
    image_description: "",
    id: 44,
    name_en: "Nine of Cups",
    name_hi: "कलश का नौ",
    vedic_name: "Tripti (The Contentment)",
    vedic_parallel: "Like Kubera's treasury — material and emotional wishes fulfilled",
    upright: {
      keywords: ["wishes fulfilled", "satisfaction", "contentment", "luxury", "gratitude"],
      meaning: "A wish comes true. Emotional and material satisfaction arrives.",
      advice: "Enjoy the abundance with gratitude. You earned this.",
    },
    reversed: {
      keywords: ["greed", "dissatisfaction despite having", "overindulgence"],
      meaning: "Having everything but feeling nothing. Gratitude is missing.",
      advice: "Count what you have before chasing what you lack.",
    },
    arcana: "minor",
    suit: "cups",
    element: "water",
    vedic_element: "jal",
    suit_theme: "Emotions, love, relationships, and spiritual connection",
  },
  {
    image_description: "",
    id: 45,
    name_en: "Ten of Cups",
    name_hi: "कलश का दस",
    vedic_name: "Parivar Sukh (Family Bliss)",
    vedic_parallel: "Like the Pandavas reunited in heaven — lasting emotional harmony and peace",
    upright: {
      keywords: ["family harmony", "emotional fulfillment", "lasting happiness", "peace"],
      meaning: "Deep family happiness and emotional wholeness. The heart is full.",
      advice: "Cherish this harmony. It is the fruit of many seasons of effort.",
    },
    reversed: {
      keywords: ["family discord", "broken dreams", "misaligned values"],
      meaning: "Household tension disrupts peace. Values may not be aligned.",
      advice: "Honest conversation heals what silence damages.",
    },
    arcana: "minor",
    suit: "cups",
    element: "water",
    vedic_element: "jal",
    suit_theme: "Emotions, love, relationships, and spiritual connection",
  },
  {
    image_description: "",
    id: 46,
    name_en: "Page of Cups",
    name_hi: "कलश का राजकुमार",
    vedic_name: "Jal Shishya (The Water Student)",
    vedic_parallel: "Like young Krishna by the Yamuna — playful, intuitive, emotionally open",
    upright: {
      keywords: ["emotional message", "intuition", "creativity", "inner child"],
      meaning: "An emotional message or creative inspiration arrives. Stay open.",
      advice: "Follow the feeling. Your intuition is speaking.",
    },
    reversed: {
      keywords: ["emotional immaturity", "escapism", "creative block"],
      meaning: "Emotions run unchecked or creativity is blocked.",
      advice: "Ground yourself before acting on raw emotion.",
    },
    arcana: "minor",
    suit: "cups",
    element: "water",
    vedic_element: "jal",
    suit_theme: "Emotions, love, relationships, and spiritual connection",
  },
  {
    image_description: "",
    id: 47,
    name_en: "Knight of Cups",
    name_hi: "कलश का शूरवीर",
    vedic_name: "Jal Veer (The Water Warrior)",
    vedic_parallel: "Like Nala crossing the ocean for Damayanti — romantic, devoted, idealistic",
    upright: {
      keywords: ["romance", "charm", "idealism", "following the heart"],
      meaning: "A romantic or idealistic energy arrives. Follow your heart with grace.",
      advice: "Be the lover and the poet. Sincerity moves mountains.",
    },
    reversed: {
      keywords: ["moodiness", "unrealistic expectations", "emotional manipulation"],
      meaning: "Idealism turns to delusion. Emotions are used to manipulate.",
      advice: "Check if your heart is leading or your ego wearing a heart-shaped mask.",
    },
    arcana: "minor",
    suit: "cups",
    element: "water",
    vedic_element: "jal",
    suit_theme: "Emotions, love, relationships, and spiritual connection",
  },
  {
    image_description: "",
    id: 48,
    name_en: "Queen of Cups",
    name_hi: "कलश की रानी",
    vedic_name: "Jal Devi (The Water Queen)",
    vedic_parallel: "Like Yashoda with infant Krishna — boundless emotional depth and compassion",
    upright: {
      keywords: ["compassion", "emotional security", "intuition", "nurturing"],
      meaning: "Deep emotional wisdom and nurturing presence. You hold space for others.",
      advice: "Trust your emotional intelligence. It sees what logic misses.",
    },
    reversed: {
      keywords: ["emotional insecurity", "codependency", "martyrdom"],
      meaning: "Giving too much of yourself. Compassion without boundaries drains you.",
      advice: "Nurture yourself first. You cannot pour from an empty vessel.",
    },
    arcana: "minor",
    suit: "cups",
    element: "water",
    vedic_element: "jal",
    suit_theme: "Emotions, love, relationships, and spiritual connection",
  },
  {
    image_description: "",
    id: 49,
    name_en: "King of Cups",
    name_hi: "कलश का राजा",
    vedic_name: "Jal Nayak (The Water King)",
    vedic_parallel: "Like King Janaka — mastery over emotions while fully engaged in the world",
    upright: {
      keywords: ["emotional balance", "generosity", "diplomatic", "calm authority"],
      meaning: "Emotional mastery with worldly engagement. Wisdom and compassion in balance.",
      advice: "Lead with emotional intelligence. Calm authority inspires trust.",
    },
    reversed: {
      keywords: ["emotional manipulation", "moodiness", "coldness"],
      meaning: "Emotions suppressed or weaponized. Control masking vulnerability.",
      advice: "Let yourself feel. Strength does not require numbness.",
    },
    arcana: "minor",
    suit: "cups",
    element: "water",
    vedic_element: "jal",
    suit_theme: "Emotions, love, relationships, and spiritual connection",
  },
] as const satisfies readonly TarotReferenceCard[];
